import { render, staticRenderFns } from "./AlbumsHeader.vue?vue&type=template&id=a6c6c9ea&scoped=true&"
import script from "./AlbumsHeader.vue?vue&type=script&lang=js&"
export * from "./AlbumsHeader.vue?vue&type=script&lang=js&"
import style0 from "./AlbumsHeader.vue?vue&type=style&index=0&id=a6c6c9ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c6c9ea",
  null
  
)

export default component.exports